import { createStore, createHook, StoreActionApi } from "react-sweet-state";
import { SavingState } from "./savingType";
import { SavingDetail } from "@/dto/savings/Savings";

export const SAVING_STORE = "StoreSaving";

type StoreApi = StoreActionApi<SavingState>;

export const initialState: SavingState = {
  savingsId: "",
  savingDetail: {
    durationType: "",
    expectedMaturityInterest: 0,
    makerDate: "",
    makerName: "",
    rollOverType: "",
    savingAmount: 0,
    savingInterest: 0,
    savingsType: "",
    interestPaymentCycle: "",
    savingAmountDisplay: "",
    savingsClassType: "",
    sourceAccountNo: "",
  },
  detailParams: [],
  infoSavingDeposit: [],
  transInfoDeposit: [],
  amountDisplay: "",
  beneficiaryAccountNo: "",
  beneficiaryAccountName: "",
  beneficiaryAvailableAmount: "",
};
export const actions = {
  setSavingDetail:
    (savingDetail: SavingDetail) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        savingDetail,
      });
    },
  setDetailParams:
    (detailParams: { key: string; value: string }[]) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        detailParams,
      });
    },
  setSavingsId:
    (savingsId: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        savingsId,
      });
    },
  setInfoSavingDeposit:
    (infoSavingDeposit: { key: string; value: string; name: string }[]) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        infoSavingDeposit,
      });
    },
  setTransInfoDeposit:
    (transInfoDeposit: { key: string; value: string; name: string }[]) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        transInfoDeposit,
      });
    },
  setAmountDisplay:
    (amountDisplay: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        amountDisplay,
      });
    },
  setBeneficiaryAccountNo:
    (beneficiaryAccountNo: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        beneficiaryAccountNo,
      });
    },
  setBeneficiaryAccountName:
    (beneficiaryAccountName: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        beneficiaryAccountName,
      });
    },
  setBeneficiaryAvailableAmount:
    (beneficiaryAvailableAmount: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        beneficiaryAvailableAmount,
      });
    },

  clearStore:
    () =>
    ({ setState }: StoreApi) => {
      setState({
        ...initialState,
      });
    },
};

type Actions = typeof actions;

const Store = createStore<SavingState, Actions>({
  initialState,
  actions,
  name: SAVING_STORE,
});

const useSavingStore = createHook(Store);

export const storeKey = `${Store.key}@__global__`;

export default useSavingStore;
